import React from "react";
import styled from "styled-components";

import { TableViewIcon } from "../../../static/icons";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 4.5rem 0 0.5rem;

  h3 {
    font-family: Roboto;
    font-weight: normal;
    font-size: 18px;
    line-height: 21px;
    color: #E5E5E5;
  }
`;

const ViewAllBtn = styled.button`
  display: flex;
  align-items: center;
  color: #E5E5E5;

  svg {
    margin: 0 14px 0 0;
  }

  &:focus {
    outline: none;
  }

  small {
    font-family: Roboto;
    font-weight: normal;
    margin-top: 2.5px;
  }
`;

const SectionHeader = ({ heading }) => (
  <Wrapper>
    <h3>{heading}</h3>
    <ViewAllBtn>
      <TableViewIcon /> <small>View All</small>
    </ViewAllBtn>
  </Wrapper>
);

export default SectionHeader;
